import { Tag } from 'antd';
import type { LanguageCode, TranslationStatusEntry } from '../../types/i18n';
import { LANGUAGE_MAP } from '../../i18n/languageOptions';

interface TranslationStatusBadgeProps {
  entry: TranslationStatusEntry | undefined;
  supportedLanguages: LanguageCode[];
}

export function TranslationStatusBadge({ entry, supportedLanguages }: TranslationStatusBadgeProps) {
  if (supportedLanguages.length <= 1 || !entry) return null;

  const statuses = supportedLanguages.map((lang) => ({
    lang,
    status: entry.perLanguage[lang] ?? 'MISSING',
  }));

  const hasAnyMissing = statuses.some((s) => s.status === 'MISSING');
  const hasAnyPartial = statuses.some((s) => s.status === 'PARTIAL');

  if (!hasAnyMissing && !hasAnyPartial) return null; // all complete — no badge needed

  return (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {statuses
        .filter((s) => s.status !== 'COMPLETE')
        .map(({ lang, status }) => {
          const opt = LANGUAGE_MAP[lang];
          const color = status === 'MISSING' ? 'error' : 'warning';
          return (
            <Tag key={lang} color={color} style={{ fontSize: 11, padding: '0 6px', margin: 0 }}>
              {opt?.flag ?? lang} {status === 'MISSING' ? '✗' : '~'}
            </Tag>
          );
        })}
    </div>
  );
}
